import React, { Component } from 'react';

class Visualizador extends Component {

    componentDidMount() {
        if(typeof window.orientation !== "undefined"){
            document.getElementById('enlaceDescargarPdf').click();
            window.close();
        }
    }
    
    render() {
        return (
            <div style={{position: 'absolute', width: '100%', height: '100%' ,zIndex:999}}>
                <object
                data={require('./Assets/USUARIO.pdf')}
                type="application/pdf"
                width="100%"
                height="100%"
                >
                    <br />
                    <a href={require('./Assets/USUARIO.pdf')} id="enlaceDescargarPdf"
                    download="Terminos y Condiciones"
                    >Tu dispositivo no puede visualizar los PDF, da click aquí para descargarlo</a>
                </object>
            </div>
        );
    }
}

export default Visualizador;